import * as z from "zod";

export const resolveTriage = {
  name: "resolveTriage" as const,
  input: z.object({
    workOrderBatchId: z.string(),
    action: z.enum([
      "back_to_picking",
      "back_to_start_of_step",
      "skip_to_step",
      "cancel_batch",
    ]),
    skipToStepId: z.string().nullish(),
  }),
  output: z.object({ success: z.boolean() }),
};
